var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`
    ${_vm.color}
    waggon-info-header
  `,style:(`width: ${_vm.width};
  ${_vm.cursor?`cursor: ${_vm.cursor}`:''};
  color: ${_vm.textcolor};
  `)},[(_vm.getNewIcon(_vm.icon))?_c('TIcon',{attrs:{"name":_vm.getNewIcon(_vm.icon),"medium":"","color":_vm.textcolor ? _vm.textcolor : 'black'}}):_vm._e(),_c('div',{staticClass:"font-weight-light mr-1"},[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.wp_part && _vm.wp_part !== 1)?_c('span',[_vm._v("["+_vm._s(_vm.wp_part)+"]")]):_vm._e()]),(_vm.selected && _vm.taktarea_name)?_c('div',{staticClass:"font-weight-light mr-1"},[_vm._v(" ("+_vm._s(_vm.taktarea_name)+") ")]):_vm._e(),_c('v-spacer'),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }